import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import api from '.';
import { GetNoticesRequestDto } from '../dtos/requests/get-notices.request.dto';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { GetNoticeResponseDto } from '../dtos/responses/get-notice.response.dto';
import { GetNoticesResponseDto } from '../dtos/responses/get-notices.response.dto';

const getNotices = (params: GetNoticesRequestDto) => {
  return api<BaseResponseDto<GetNoticesResponseDto[]>, Error>(
    `/student/notice?${queryString.stringify(params)}`,
    {
      method: 'GET',
    },
  );
};

export const useGetNotices = (
  params: GetNoticesRequestDto,
  options?: Omit<UseQueryOptions<BaseResponseDto<GetNoticesResponseDto[]>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'notice', params],
    queryFn: () => getNotices(params),
    ...options,
  });
};

const getNotice = (noticeId?: string) => {
  return api<BaseResponseDto<GetNoticeResponseDto>, Error>(`/student/notice/${noticeId}`, {
    method: 'GET',
  });
};

export const useGetNotice = (
  noticeId?: string,
  options?: Partial<Omit<UseQueryOptions<BaseResponseDto<GetNoticeResponseDto>, Error>, 'queryFn'>>,
) => {
  return useQuery({
    queryKey: ['student', 'notice', noticeId],
    queryFn: () => getNotice(noticeId),
    ...options,
  });
};
